export abstract class AppConfiguration {
    recordsAppUrl: string;
    showLoginButton: boolean;
}